/**
 * URL to the Atlassian support documentation for synced blocks in Confluence Cloud.
 */
export const SYNCED_BLOCKS_DOCUMENTATION_URL =
	'https://support.atlassian.com/confluence-cloud/docs/reuse-content-with-synced-blocks';
